import React from 'react'

import { INVENTORY_ITEMS_STATUS } from '../../Inventory/components/InventoryItemsStatusSelector';
import EPCLink from "../../component/Asset/EPCLink";


class InventoryItemsGrid {
  columns = [
    {
      Header: "EPC's",
      accessor: 'asset.tags.value',
      sortable: false,
      Cell: ({ original }) => original.asset && original.asset.tags && original.asset.tags.map((x, i) => (<li key={i}> <EPCLink epc={x}/> </li>)) || 'Sem dados'
    },
    {
      Header: 'Referência',
      accessor: 'asset.productType.reference',
      sortable: false
    },
    {
      Header: 'Nome',
      accessor: 'asset.productType.friendlyName',
      sortable: false
    },
    {
      Header: 'Esperado',
      accessor: 'expected',
      Cell: ({original}) => original.expected ? 'Sim' : 'Não'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: ({original}) => original.status && INVENTORY_ITEMS_STATUS[original.status] || 'Sem dados'
    },
  ];

  endpoint = (inventoryId, params) => `/inventory/v1/inventories/${inventoryId}/items?${params}`
}

export default InventoryItemsGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/InventoryItemsGrid.js